import React, { lazy, Suspense } from 'react';
import { Box } from '@mui/material';
import SttCarregando from '../../../componentes/comum/SttCarregando/SttCarregando';

const Modulos = lazy(() => import('../../../componentes/modulos'));

const IndexModulos = () => {
    return (
        <Box sx={{ padding: 1 }}>
            <Suspense fallback={<SttCarregando />}>
                <Modulos />
            </Suspense>
        </Box>
    );
};

export default IndexModulos;
